class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

   // removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = this.resolveCartItemKey(parsedState);

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const sectionHTML = parsedState.sections?.[section.id];
      if (!target || !sectionHTML) return;

      const innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
      if (innerHTML != null) target.innerHTML = innerHTML;
    });

    refreshHeaderCartIcon();

    if (this.header) this.header.reveal();
    this.open();
  }

  resolveCartItemKey(parsedState) {
    if (parsedState.key) return parsedState.key;

    const items = parsedState.items;
    if (!Array.isArray(items) || !items.length) return null;

    const mainVariantId = parsedState.variant_id || parsedState.id;
    if (mainVariantId) {
      const mainItem = items.find((item) => String(item.id) === String(mainVariantId));
      if (mainItem?.key) return mainItem.key;
    }

    return items[items.length - 1]?.key || items[0]?.key || null;
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-notification-product',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];

    if (this.cartItemKey) {
      sections[0].selector = `[id="cart-notification-product-${this.cartItemKey}"]`;
    }

    return sections;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    if (selector) {
      const match = parsed.querySelector(selector);
      if (match) return match.innerHTML;
    }

    return parsed.querySelector('.shopify-section')?.innerHTML ?? '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
